"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailRegistrationFormContainer = EmailRegistrationFormContainer;
var React = _interopRequireWildcard(require("react"));
var _EmailRegistrationForm = require("../../../../components/EmailRegistrationForm");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function EmailRegistrationFormContainer(_ref) {
  let {
    isSubmitting,
    login,
    loginError,
    isLoginInvalid,
    hasAsyncLoginError,
    password,
    passwordError,
    isPasswordInvalid,
    hasAsyncPasswordError,
    changeLogin,
    changePassword,
    register,
    autoFocusDisabled,
    isProfessionalUser,
    source
  } = _ref;
  // FORM
  const [changed, setChanged] = React.useState(false);
  const [touched, setTouched] = React.useState(false);

  // LOGIN
  const loginRef = React.useRef(null);
  const handleLoginChange = e => {
    const {
      value
    } = e.currentTarget;
    changeLogin(value.trim());
    setChanged(true);
  };
  React.useEffect(() => {
    if (loginRef.current) {
      loginRef.current.focus();
    }
  }, []);

  // PASSWORD
  const passwordRef = React.useRef(null);
  const handlePasswordChange = e => {
    const {
      value
    } = e.currentTarget;
    changePassword(value);
    setChanged(true);
  };
  const [passwordShown, setPasswordShown] = React.useState(false);
  const togglePasswordVisibility = React.useCallback(() => setPasswordShown(!passwordShown), [passwordShown]);

  // SUBMITION
  const handleFocusInvalid = React.useCallback(() => {
    if (isLoginInvalid && loginRef.current) {
      loginRef.current.focus();
      return;
    }
    if (isPasswordInvalid && passwordRef.current) {
      passwordRef.current.focus();
      return;
    }
  }, [isPasswordInvalid, isLoginInvalid]);
  const handleSubmit = () => {
    setTouched(true);
    if (isLoginInvalid || isPasswordInvalid) {
      handleFocusInvalid();
      return;
    }
    register({
      email: login,
      password,
      isProfessional: isProfessionalUser,
      source
    });
    setChanged(false);
  };
  React.useEffect(() => {
    setPasswordShown(false);
    if (passwordRef.current) {
      setTouched(false);
      setChanged(false);
      passwordRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/React.createElement(_EmailRegistrationForm.EmailRegistrationForm, {
    handleSubmit: handleSubmit,
    isSubmitting: isSubmitting,
    autoFocusDisabled: autoFocusDisabled
    // LOGIN
    ,
    loginRef: loginRef,
    login: login,
    onLoginChange: handleLoginChange,
    loginError: !changed && loginError || undefined,
    isLoginInvalid: touched && (isLoginInvalid || !changed && hasAsyncLoginError)
    // PASSWORD
    ,
    passwordRef: passwordRef,
    password: password,
    passwordShown: passwordShown,
    isPasswordInvalid: touched && (isPasswordInvalid || !changed && hasAsyncPasswordError),
    passwordError: passwordError,
    togglePasswordVisibility: togglePasswordVisibility,
    onPasswordChange: handlePasswordChange
  });
}